import React, { useContext } from 'react'
import { navigate } from 'gatsby'
import qs, { parse } from 'query-string'

import StoreContext from '~/context/StoreContext'

import { BodyCopy } from '~/components/Typography'
import Preview from '~/components/Preview'

import {
  Wrapper,
  ItemCol,
  ItemImage,
  ItemContent,
  ItemImageWrapper,
  Title,
  Attribute,
  Button,
  MobileLabel,
  Striked,
} from './styles'

const LineItem = ({ line_item }) => {
  const { variant, title, quantity, customAttributes, id } = line_item
  const {
    removeLineItem,
    store: { client, checkout },
  } = useContext(StoreContext)

  const options = {
    style: title,
  }

  variant.selectedOptions.map(({ name, value }) => {
    options[name] = value
  })

  customAttributes.forEach(({ key, value }) => {
    if (!key || key === 'query') return

    if (key.toLowerCase() === 'personalised text') {
      key = 'personalisedText'
    } else if (key.toLowerCase() === 'personalised text 2') {
      key = 'personalisedText2'
    } else {
      key = key.toLowerCase()
    }

    options[key] = value
  })

  const attributes = {
    Character: 'Bogstav',
    Color: 'Farve',
    'Personalised text': 'Navn',
    'Personalised text 2': 'Undertekst',
  }

  const discount = line_item.discountAllocations
    .map(({ allocatedAmount }) => allocatedAmount.amount)
    .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)

  return (
    <Wrapper>
      <ItemCol>
        <ItemImageWrapper>
          <ItemImage
            size={options.size}
            onClick={() => navigate(`/?${qs.stringify(options)}`)}
          >
            <Preview config={options} />
          </ItemImage>
        </ItemImageWrapper>
        <ItemContent>
          <Title>{title}</Title>
          <Attribute>
            <strong>Plakat størrelse:</strong> {options.size}
          </Attribute>
          <Attribute>
            <strong>Ramme:</strong> {options.frame}
          </Attribute>
          {customAttributes.map(
            ({ key, value }) =>
              key !== 'query' &&
              key !== 'Scale' &&
              key !== 'Inverted' &&
              key !== 'Layout' &&
              value && (
                <Attribute key={key}>
                  <strong>{attributes[key]}:</strong> {value}
                </Attribute>
              )
          )}
        </ItemContent>
      </ItemCol>
      <ItemCol>
        <MobileLabel>Price</MobileLabel>
        <BodyCopy>
          {discount > 0 ? (
            <Striked>
              {variant.price} {variant.priceV2.currencyCode}
            </Striked>
          ) : (
            `${variant.price} ${variant.priceV2.currencyCode}`
          )}{' '}
          {discount > 0 &&
            `${variant.price - discount} ${variant.priceV2.currencyCode}`}
        </BodyCopy>
      </ItemCol>
      <ItemCol>
        <MobileLabel>Quantity</MobileLabel>
        <Button tag="div">
          <BodyCopy>{quantity}</BodyCopy>
          <button
            style={{ background: 'transparent' }}
            onClick={() => removeLineItem(client, checkout.id, id)}
          >
            Slet
          </button>
        </Button>
      </ItemCol>
      <ItemCol>
        <MobileLabel>Total</MobileLabel>
        <BodyCopy>
          {parseFloat(variant.price * quantity).toFixed(2) - discount}{' '}
          {variant.priceV2.currencyCode}
        </BodyCopy>
      </ItemCol>
    </Wrapper>
  )
}

export default LineItem
